import { postCall } from 'sharedKernel/api'
import { PUBLIC_MEETING_ROOM_API } from './constants'

export interface IPublicReservationAvailabilityPayload {
  meetingRoomIds: string[]
  reservationDate: string
  endDate: string
  startTime: string
  endTime: string
}

// PLA-3423: pré-checagem tudo-ou-nada — devolve as salas com reserva aprovada no período.
export const checkRoomsAvailability = async (payload: IPublicReservationAvailabilityPayload): Promise<string[]> => {
  const response = await postCall({
    url: PUBLIC_MEETING_ROOM_API.CHECK_AVAILABILITY,
    isPublic: true,
    data: payload,
  })
  const data = response.data?.data ?? response.data
  const blocked: unknown = data?.blockedMeetingRoomIds
  return Array.isArray(blocked) ? blocked.map(String) : []
}
